export default __webpack_public_path__ + "static/media/logo.b2af59bd.svg";